import { Injectable } from '@angular/core';
import { JwtHelperService } from '@auth0/angular-jwt';
import { BehaviorSubject, Observable, of } from 'rxjs';

import { CooperativeModel } from '../models/cooperative.model';
import { TokenCooperativeService } from '../token/token-cooperative.service';

@Injectable({ providedIn: 'root' })
export class UserCooperativeService {
  private userSubject = new BehaviorSubject<CooperativeModel | null>(null);
  avatarSubject = new BehaviorSubject<any>(false);
  jwtHelper = new JwtHelperService();

  constructor(private tokenService: TokenCooperativeService) {
    // Verificar se há token de cooperative e decodificar
    this.tokenService.hasToken() && this.decodeAndNotify();
  }

  setToken(token: string): void {
    this.tokenService.setToken(token);
    this.decodeAndNotify();
  }

  setUser(user: CooperativeModel): void {
    this.userSubject.next(user);
  }

  getUser(): Observable<CooperativeModel | null> {
    return this.userSubject.asObservable();
  }

  logout(): void {
    this.tokenService.removeToken();
    this.userSubject.next(null);
  }

  isLogged(): boolean {
    return this.tokenService.hasToken();
  }

  isTokenExpired() {
    if (this.tokenService.hasToken()) {
      const token = this.tokenService.getToken();
      const isExpired = this.jwtHelper.isTokenExpired(token);

      return isExpired;
    }

    return false;
  }

  getUserRoles(): Observable<any> {
    const user = this.userSubject.value;

    if (user) {
      return of(user.roles);
    }

    return of([]);
  }

  hasRole(role: string): boolean {
    const user = this.userSubject.value;
    return user ? user.roles.includes(role) : false;
  }

  private decodeAndNotify(): void {
    try {
      const token = this.jwtHelper.decodeToken(
        this.tokenService.getToken() as string
      );
      const user = JSON.parse(token.user);
      this.userSubject.next(user);
      this.avatarSubject.next(true);
    } catch (error) {
      this.logout();
    }
  }
}
